var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll_button",on:{"click":function($event){return _vm.smoothScrollTo(_vm.target_selector, _vm.scroll_to_bottom)}}},[_vm._v("\n\t"+_vm._s(_vm.scroll_to_bottom == (true || '1') ? '↓' : '↑')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ScrollButton.vue